import { Button } from "@/components/ui/button";
import { ArrowRight, HelpCircle } from "lucide-react";

const CallToAction = () => {
  return (
    <section className="py-20 bg-[#1e4d0b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
            Por que escolher a GoPass?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Bloco 1 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <ArrowRight className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Tecnologia de Ponta
                </h4>
                <p className="text-white/80">
                  Plataforma robusta e confiável, desenvolvida especificamente
                  para o mercado brasileiro de mobilidade.
                </p>
              </div>
            </div>

            {/* Bloco 2 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <ArrowRight className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Suporte Completo
                </h4>
                <p className="text-white/80">
                  Treinamento, marketing, suporte técnico e operacional
                  para garantir seu sucesso desde o primeiro dia.
                </p>
              </div>
            </div>

            {/* Bloco 3 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <ArrowRight className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Modelo de Negócio Comprovado
                </h4>
                <p className="text-white/80">
                  Sistema testado e aprovado por dezenas de licenciados
                  em todo o Brasil com resultados mensuráveis.
                </p>
              </div>
            </div>

            {/* Bloco 4 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <ArrowRight className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Crescimento Escalável
                </h4>
                <p className="text-white/80">
                  Comece local e expanda gradualmente, com ferramentas
                  para crescer de forma sustentável e lucrativa.
                </p>
              </div>
            </div>

            {/* Bloco 5 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Como saber se existe em minha cidade?
                </h4>
                <p className="text-white/80">
                  Agende uma reunião com nossos especialistas e tire essa e outras dúvidas.
                </p>
              </div>
            </div>

            {/* Bloco 6 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  É possível competir com a Uber?
                </h4>
                <p className="text-white/80">
                  Motoristas e passageiros buscam melhores condições e na GoPass,
                  temos 4 diferenciais competitivos que vêm fazendo com que tenhamos
                  grande aceitação do mercado.
                </p>
              </div>
            </div>

            {/* Bloco 7 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  O retorno do Licenciado regional é garantido?
                </h4>
                <p className="text-white/80">
                  Todo negócio possui riscos, mas se você seguir nossas orientações
                  e treinamento, seu risco diminui significativamente e seus resultados
                  estarão alinhados com o plano de negócios. Se você comprovar que seguiu
                  nossas orientações e ainda assim não tiver resultados no período projetado,
                  recompramos sua unidade licenciada. Isso é garantido em contrato.
                </p>
              </div>
            </div>

            {/* Bloco 8 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  Como é feito o marketing?
                </h4>
                <p className="text-white/80">
                  Nossa matriz faz o marketing digital e o Licenciado recebe
                  um mídia kit para fazer o marketing local em sua cidade.
                </p>
              </div>
            </div>

            {/* Bloco 9 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  A GoPass é confiável?
                </h4>
                <p className="text-white/80">
                  Nos últimos 7 anos a empresa investiu dezenas de milhões em tecnologia
                  de ponta, adicionou 4 diferenciais inovadores e competitivos ao seu modelo
                  de negócios. Validou com dezenas de milhares de usuários em 41 cidades
                  em todo o Brasil. Portanto, sim, é totalmente confiável e uma grande
                  oportunidade de negócio.
                </p>
              </div>
            </div>

            {/* Bloco 10 */}
            <div className="flex items-start space-x-4">
              <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mt-1">
                <HelpCircle className="w-4 h-4 text-white" />
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">
                  É possível um parceiro regional não se adaptar?
                </h4>
                <p className="text-white/80">
                  Sim, é possível! Desde que ele não siga as instruções da Matriz,
                  não execute o plano de marketing e acredite que o resultado ocorrerá
                  sem nenhum trabalho. Se esse for o seu caso, NÃO seja um de nossos parceiros.
                </p>
              </div>
            </div>
          </div>

          {/* Botão agendar reunião */}
          <div className="mt-12 text-center">
            <a
              href="https://calendly.com/brunocastro/reuniao-online-gopass-mobilidade"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                variant="outline"
                size="lg"
                className="text-lg px-8 py-4 border-blue-300 text-white bg-blue-500/10 hover:bg-blue-500/20"
              >
                Agendar Reunião Online
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
